import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setMarket, setRunner, setIsBack, setPrice, setPriceActual, setStake, setDelay, setMtype, setBtype, setLine, setRunnerName, setEventName, setFromOneClick } from '../../../store/betPlacing/betPlacing.slice'
import { requestBetPlacingStart } from '../../../store/betPlacing/betPlacing.thunks'
import { requestExchangeGames } from '../../../store/exchangeGames/exchangeGames.thunks'

export const connectBaccarat = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      sportEvent: state.sportEvent,
      betPlacing: state.betPlacing,
      exchangeGames: state.exchangeGames,
      exposure: state.eventPage.exposure,
      headerHeight: state.elementsParams.headerHeight,
      auth: state.auth,
      elementsParams: state.elementsParams
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setMarket,
      setRunner,
      setRunnerName,
      setEventName,
      setIsBack,
      setPrice,
      setPriceActual,
      setDelay,
      setStake,
      setMtype,
      setBtype,
      setLine,
      setFromOneClick,
      requestBetPlacingStart,
      requestExchangeGames
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
